export const capitaliseFirstLetter = (str: string | null | undefined) => {
  if (!str || str.length === 0) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
